// A list of PIDs of partners to consider when determining if SMS messages will be sent via Broadly 1.0.
// NOTE: This is a front-end indicator only, the backend will determine the actual sending method.
export const BROADLY_SMS_PIDS = [
  'NBLY',
  'PRBS',
  'CHOW', // Used in demo for testing Broadly SMS features
];

export const COUNTRIES_REQUIRING_REGISTRATION = ['us', 'it', 'au'];

export const COUNTRIES_REQUIRING_A2P_REGISTRATION = ['us'];

/**
 * Calculates countries that require regulatory compliance but not A2P registration.
 * This is the difference between countries requiring registration and those requiring A2P registration.
 * @returns Array of country codes requiring regulatory compliance (excluding A2P registration)
 */
export function getCountriesRequiringRegulatoryCompliance(): string[] {
  return COUNTRIES_REQUIRING_REGISTRATION.filter((country) => !COUNTRIES_REQUIRING_A2P_REGISTRATION.includes(country));
}

export enum Country {
  SouthAfrica = 'South Africa',
  Italy = 'Italy',
  US = 'US',
  Australia = 'Australia',
}

export const COUNTRY_CODE_TO_COUNTRY: Record<string, Country> = {
  us: Country.US,
  it: Country.Italy,
  za: Country.SouthAfrica,
  au: Country.Australia,
};

export function countryFromCode(countryCode: string | undefined): Country | undefined {
  const code = countryCode?.toLowerCase();
  return code ? COUNTRY_CODE_TO_COUNTRY[code] : undefined;
}

/** Countries whose registration flow has the post-approval phone-number provisioning step. */
export const COUNTRIES_WITH_NUMBER_PROVISIONING: ReadonlySet<Country> = new Set([Country.Italy]);

export function hasNumberProvisioningStep(country: Country | undefined): boolean {
  return !!country && COUNTRIES_WITH_NUMBER_PROVISIONING.has(country);
}
